<template>
  <footer class="site-footer" data-build="site-footer-v6">
    <div class="wrapper footer-main">
      <div class="footer-columns">
        <div class="footer-col" v-for="group in navGroups" :key="group.title">
          <h4>{{ group.title }}</h4>
          <a v-for="item in group.items" :key="item.label" class="footer-link" @click="handleItem(item)">
            {{ item.label }}
          </a>
        </div>

        <div class="footer-col contact-col">
          <h4>{{ $t('footerGroupContact') }}</h4>
          <p v-if="siteConfig.phone">TEL: {{ siteConfig.phone }}</p>
          <p v-if="siteConfig.email">E-Mail: {{ siteConfig.email }}</p>
          <p v-if="siteConfig.address" class="contact-address">ADDR.: {{ siteConfig.address }}</p>
        </div>

        <div class="footer-qr">
          <span class="qr-box">
            <img v-if="siteConfig.wechatQr" :src="siteConfig.wechatQr" alt="Official WeChat QR" />
            <span v-else class="qr-placeholder">QR</span>
          </span>
          <p>{{ $t('footerOfficialWechat') }}</p>
          <p v-if="siteConfig.wechatId">{{ siteConfig.wechatId }}</p>
        </div>
      </div>

      <div class="footer-copy">
        <span>{{ copyrightText }}</span>
        <span v-if="siteConfig.icp" class="divider">|</span>
        <span v-if="siteConfig.icp">{{ siteConfig.icp }}</span>
        <span v-if="siteConfig.police" class="divider">|</span>
        <span v-if="siteConfig.police" class="police-text">
          <img class="police-icon" :src="gonganIcon" alt="" aria-hidden="true" />
          {{ siteConfig.police }}
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
import gonganIcon from '@/assets/icons/gongan.png'
import { getHomeSiteConfig } from '@/request/apis/home'

export default {
  props: {
    settingBk: {
      type: String,
      default: '#4b5259'
    }
  },
  data() {
    return {
      gonganIcon,
      siteConfig: {}
    }
  },
  computed: {
    copyrightText() {
      const year = new Date().getFullYear()
      return this.siteConfig.company
        ? `Copyright © ${year} ${this.siteConfig.company}`
        : `Copyright © ${year}`
    },
    navGroups() {
      return [
        {
          title: this.$t('footerGroupCompany'),
          items: [
            { label: this.$t('footerAboutUs'), path: '/about' },
            { label: this.$t('footerMenuConsult'), path: '/consult' },
            { label: this.$t('footerLatestNews'), path: '/news' }
          ]
        },
        {
          title: this.$t('footerGroupService'),
          items: [
            { label: this.$t('footerServiceScale'), path: '/product' },
            { label: this.$t('footerServiceTraining'), path: '/train' },
            { label: this.$t('footerServiceScoring'), type: 'jifen' }
          ]
        },
        {
          title: this.$t('footerGroupLaw'),
          items: [
            { label: this.$t('footerLawTerms'), path: '/about/terms' },
            { label: this.$t('footerLawIP'), path: '/about/know' },
            { label: this.$t('footerLawPrivacy'), path: '/about/other', query: { type: 1 } }
          ]
        }
      ]
    }
  },
  created() {
    this.loadSiteConfig()
  },
  methods: {
    loadSiteConfig() {
      const lang = localStorage.getItem('locale') || 'zh'
      getHomeSiteConfig(lang).then((config) => {
        this.siteConfig = config || {}
      }).catch(() => {
        this.siteConfig = {}
      })
    },
    handleItem(item) {
      if (item.type === 'jifen') {
        window.open('https://www.hsyl-tech.com/scaleClient/', '_blank')
        return
      }
      if (!item.path) return
      this.$router.push({ path: item.path, query: item.query || {} })
    }
  }
}
</script>

<style scoped>
.site-footer {
  background: #4b5259;
  color: #ffffff;
}

.site-footer .wrapper {
  width: var(--site-container);
  max-width: calc(100% - var(--site-gutter));
}

.footer-main {
  padding-top: 78px;
  padding-bottom: 46px;
}

.footer-columns {
  display: grid;
  grid-template-columns: 1fr 1fr 0.9fr minmax(250px, 1.6fr) 150px;
  gap: 42px;
  align-items: start;
}

.footer-col h4 {
  font-size: 18px;
  line-height: 1.2;
  color: #ffffff;
  font-family: var(--font-heading);
  font-weight: 600;
  margin-bottom: 22px;
}

.footer-link,
.footer-col p,
.footer-qr p {
  display: block;
  font-size: 14px;
  line-height: 2.2;
  color: rgba(255, 255, 255, 0.88);
  font-family: var(--font-body);
}

.footer-qr p {
  white-space: nowrap;
  font-size: 12px;
}

.footer-link {
  cursor: pointer;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: #ffffff;
}

.contact-col {
  min-width: 0;
}

.contact-col p {
  white-space: nowrap;
}

.contact-col .contact-address {
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
}

.footer-qr {
  padding-left: 35px;
  border-left: 1px solid rgba(255, 255, 255, 0.34);
  min-height: 101px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.qr-box {
  width: 78px;
  height: 78px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #ffffff;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
}

.qr-box img {
  display: block;
  width: 77px;
  height: 77px;
  object-fit: contain;
  object-position: center;
  margin: 0;
  transform: none;
}

.qr-placeholder {
  color: #4b5259;
  font-size: 18px;
  font-family: var(--font-heading);
  font-weight: 600;
  letter-spacing: 1px;
}

.footer-copy {
  max-width: 860px;
  margin-top: 42px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.34);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.88);
  font-size: 13px;
  line-height: 1.8;
  font-family: var(--font-body);
  text-align: center;
}

.divider {
  opacity: 0.7;
}

.police-text {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.police-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex: none;
}

@media (max-width: 1020px) {
  .footer-columns {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 30px;
  }

  .footer-qr {
    padding-left: 0;
    border-left: 0;
  }
}

@media (max-width: 860px) {
  .footer-main {
    padding-top: 42px;
    padding-bottom: 38px;
  }

  .footer-columns {
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }

  .footer-col h4 {
    font-size: 18px;
    margin-bottom: 16px;
  }

  .footer-link,
  .footer-col p,
  .footer-qr p,
  .footer-copy {
    font-size: 13px;
    line-height: 1.9;
  }

  .contact-col p {
    white-space: normal;
  }

  .footer-qr {
    padding-left: 0;
    border-left: 0;
    min-height: 0;
  }

  .qr-box {
    width: 102px;
    height: 102px;
    margin-bottom: 10px;
  }

  .qr-box img {
    width: 116px;
    height: 116px;
    transform: translate(-7px, -7px);
  }

  .footer-copy {
    margin-top: 28px;
    padding-top: 16px;
    gap: 8px;
  }

  .police-icon {
    width: 18px;
    height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/footer/index.vue